import { AppBar, Toolbar, Container } from "@mui/material";
import { CandeaLink } from "@components/base/Logos";

function NavBar({ navBarRef }) {
  return (
    <AppBar position="sticky">
      <Container maxWidth="xl">
        <Toolbar sx={{ minHeight: "0px !important" }} disableGutters>
          <CandeaLink />
        </Toolbar>
      </Container>
    </AppBar>
  );
}

export default NavBar;
